/**
 	 * 腾讯音视频相关sdk信息配置
 	 * @param flag 
 	 * @returns 
 	 */
 export const APPCONFG = (flag) => {
  let config = {
    APPID: 1400694143,
    APPSECRET: 'f619478ee97dc0c338ad210d26c7f5b000c8a9d20eafd5a282ae38a340677217'
  }
  switch(flag) {
    case 'pre':
      config = { ...config, ...{
        APPID: 1400694207,
        APPSECRET: 'bb4453da6142be54d86672e6c96432a3160e4ba4c034a226a66a168792397a84'
      }}
      break;
    case 'production':
      config = { ...config, ...{
        // APPID: 1400596395,
        // APPSECRET: '9b225b108e41a8ec2d0ac2ce6cbf1c07b19c1633072645abd035a1acac6b515f'
        APPID: 1400677520,
        APPSECRET: 'ee2265b429f7e2652292c548df809f3378f5ef0c41b1ff5c5d77bd453af70026'
      }}
      break; 
  }
  return config
}